import React from 'react';
import PropTypes from 'prop-types';
import SvgText from '../svgText';
import { Box } from 'reflexbox';
import Text from 'components/Text';
import './storeLocation.styles.scss';

const StoreLocation = ({aisle, bin}) => (
    <Box flex className="store-location">
        <SvgText
            className="location-box"
            backgroundColor="rgb(255,0,0)"
            text={aisle}
            height="1.5rem"
            width="3rem"
        />
        <span className="product__location-marker">
            <Text textKey="product_location_aisle" />
        </span>
        <SvgText
            className="location-box"
            backgroundColor="rgb(255,0,0)"
            text={bin}
            height="1.5rem"
            width="3rem"
        />
        <span className="product__location-marker">
            <Text textKey="product_location_bin" />
        </span>
    </Box>

);

StoreLocation.propTypes = {
    aisle: PropTypes.string.isRequired,
    bin: PropTypes.string.isRequired,
};

export default StoreLocation;
